<template>
  <b-container v-if="this.type" fluid>
    <b-container>
      <h1 v-translate="{ countdown }">Incidences Panel <small>(Autorefresh in %{countdown}s)</small></h1>
      <b-row>
        <b-col>
          <label class="" for="inline-form-input-name" v-translate>Date Range <em>(120 days max.)</em></label><label
            v-show="updatedDateRangeActive !== 0">&nbsp;[<a href="#" @click.prevent="resetupdatedDateRange"
              v-translate>reset range</a>]</label>
          <date-range-picker v-if="datepickerLocalized" v-model="updatedDateRange" :locale-data="locale" :opens="opens"
            class="mb-2 w-100" :ranges="ranges" @update="updateValues">
            <div slot="input" slot-scope="picker">
              <font-awesome-icon :icon="['far', 'calendar-alt']" size="1x" style="vertical-align: middle" />
              <span v-show="updatedDateRangeActive === 0" style="vertical-align: middle" v-translate>Last 7 days</span>
              <span v-show="updatedDateRangeActive !== 0"
                style="vertical-align: middle">{{ moment(updatedDateRange.startDate).format('L') }} -
                {{ moment(updatedDateRange.endDate).format('L') }}</span>
            </div>
          </date-range-picker>
        </b-col>
        <b-col>
          <label v-translate>Current status</label>
          <b-form-radio-group v-model="statuses"
            :options="[{ text: $gettext('All'), value: 'all' }, { text: $gettext('Incidences'), value: 'incidences' }]"></b-form-radio-group>
        </b-col>
        <b-col>
          <label v-translate>Door AI Checker</label>
          <b-input-group>
            <b-form-input v-model="validPercentage" type="number" max="100" min="0"></b-form-input>
            <b-input-group-append>
              <b-button variant="primary" @click.prevent="setInterval" size="sm" v-translate>
                Set Max. %
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col v-if="!$cookies.get('bypassCountry') && warehousesSelect.length > 0" cols="3">
          <b-form-group>
            <label for="filter-warehouse" v-translate>Select Origin Warehouse</label>
            <b-form-select v-model="filterWarehouse" :options="warehousesSelect">
              <template slot="first">
                <option :value="null" v-translate>None</option>
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-card>
        <b-row>
          <b-col v-if="shippingStatusReason.length > 0" v-for="(shippingStatusReason, index) in shippingStatusReasons"
            :key="index">
            <h2
              v-translate="{ status: index === 'CONFIRMED' ? 'PICKEDUP' : (index === 'INTRANSIT' ? 'DELIVERED' : 'RETURNED') }">
              Before %{status}</h2>
            <h5 v-for="(theReason, index) in shippingStatusReason" :key="index">
              <b-link @click="typeSelected = 0; typeSelected = theReason.reason_id"><b-badge
                  :variant="incidencesCount[theReason.reason_id] <= 5 ? 'success' : (incidencesCount[theReason.reason_id] > 5 && incidencesCount[theReason.reason_id] <= 10 ? 'warning' : 'danger')">{{ incidencesCount[theReason.reason_id] }}</b-badge>
                {{ theReason.name }}</b-link>
            </h5>
          </b-col>
        </b-row>
      </b-card>
    </b-container>
    <div v-if="typeSelected">
      <h2 v-translate="{ type: incidenceReasons.find(x => x.id === typeSelected).name }">%{type} INCIDENCEs</h2>
      <b-table :id="type" :tbody-tr-class="markAsNew" stacked="md" foot-clone :total-rows="totalRows"
        :sort-desc="sortDesc" :sort-by="sortBy" :per-page="perPage" :current-page="currentPage" :busy="false"
        :fields="fields" :items="incidences[typeSelected]" :filter="applyFilter">

        <div slot="table-busy" class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong v-translate>Loading...</strong>
        </div>

        <template v-slot:cell(id)="data"><a :href="'/edit/' + type + '/' + data.value" target="_blank">{{ data.value |
            uuid }}</a> <a href="#" @click.prevent="copyToClipboard(data.value)" class="text-secondary"
            :title="$gettext('Copy to Clipboard')"><font-awesome-icon :icon="['far', 'copy']"
              size="1x" /></a></template>

        <template v-slot:cell(company_id)="row">
          <div v-if="row.item.company_id">
            <b-badge variant="dark" v-translate>Company</b-badge><br>
            <a :href="'/edit/companies/' + row.item.company_id" target="_blank">#{{ row.item.company_id }}</a>
            {{ row.item.company.name }}
          </div>
          <div v-else>
            <b-badge variant="secondary" v-translate>Particular</b-badge><br>
            <a :href="'/edit/users/' + row.item.user_id" target="_blank">#{{ row.item.user_id }}</a>
            {{ row.item.user.name }}
          </div>
        </template>

        <template v-slot:cell(from_contact)="row">
          <strong>{{ row.item.from_contact }}</strong><br>
          <span v-if="row.item.from_phone"><a
              :href="'tel:' + row.item.from_phone">{{ row.item.from_phone }}</a><br></span>
          <span v-if="row.item.from_email">{{ row.item.from_email }}<br></span>
          <span class="shipping-address-listings" :title="row.item.address_from.formatted_address">
            {{ row.item.address_from.formatted_address }}
          </span>
        </template>

        <template v-slot:cell(to_contact)="row">
          <strong>{{ row.item.to_contact }}</strong><br>
          <span v-if="row.item.to_phone"><a :href="'tel:' + row.item.to_phone">{{ row.item.to_phone }}</a><br></span>
          <span class="shipping-address-listings" :title="row.item.address_to.formatted_address">
            {{ row.item.address_to.formatted_address }}
          </span>
        </template>

        <template v-slot:cell(updated_at)="row">
          <span
            :class="moment.utc(row.item.updated_at).tz($tz).format('H') < 8 || moment.utc(row.item.updated_at).tz($tz).format('H') > 23 ? 'text-danger' : ''">
            {{ moment.utc(row.item.updated_at).tz($tz).format('YYYY-MM-DD') }}<br>
            {{ moment.utc(row.item.updated_at).tz($tz).format('HH:mm:ss') }}
          </span>
        </template>

        <template v-slot:cell(incidence_count)="row">
          {{ row.item.status }}<br>
          <div v-for="(item, index) in filterIncidenceTypes(row.item.status_history)" :key="index">
            {{ item }} ({{ countIncidenceTypes(row.item.status_history, item) }})
          </div>
        </template>

        <template v-slot:cell(photos)="row">
          <span v-if="row.item.photos.length > 0 && row.item.photos.findIndex(x => x.type === 'INCIDENCE') !== -1">
            <div v-for="(photo, index) in row.item.photos" :key="row.item.id + index" href="#"
              v-if="photo.type === 'INCIDENCE'">
              <a :class="moment.utc(photo.updated_at).tz($tz).format('H') < 8 || moment.utc(row.item.updated_at).tz($tz).format('H') > 23 ? 'text-danger' : ''"
                href="#" v-b-modal.modalShowPicture @click.prevent="currentPicture = photo.full_path">
                <img :src="photo.full_path" alt=""
                  style="height: auto; width: auto; max-height: 80px; max-width: 80px;"><br>
                <span>
                  {{ moment.utc(photo.updated_at).tz($tz).format('L LT') }}
                  <span v-if="photo.valid_percentage"><br />
                    <translate>Valid by:</translate>
                    <strong>{{ photo.valid_percentage }}%</strong></span>
                </span>
              </a>
            </div>
          </span>
        </template>

        <template v-slot:cell(courier)="row">
          <div v-if="row.item.courier">
            <user-card :user='row.item.courier' :profile-picture="false" :with-titles="false"
              :vehicle-types-prop="vehicleTypes" />
          </div>
        </template>

        <template v-slot:cell(actions)="row">
          <div v-if="row.item.status === 'INCIDENCE'">
            <b-button block size="sm" @click.prevent="setAsReady(row.item.id)" style="padding: .05rem .65rem"
              v-translate>
              Set As READY
            </b-button>
            <b-button block size="sm" @click.prevent="setAsWaiting(row.item.id)" style="padding: .05rem .65rem"
              v-translate>
              Set As WAITING
            </b-button>
            <b-button block size="sm" v-if="(typeSelected > 8 && incidenceReasons.find(x => x.id === typeSelected).name === 'absent_client') ||
              (typeSelected > 8 && incidenceReasons.find(x => x.id === typeSelected).name === 'unrecognized') ||
              (typeSelected > 8 && incidenceReasons.find(x => x.id === typeSelected).name === 'incorrect_address') ||
              incidenceReasons.find(x => x.id === typeSelected).name === 'rejected'" variant="warning"
              @click.prevent="editingShipping = row.item.id" style="padding: .05rem .65rem"
              v-b-modal.modalTobereturnedReason v-translate>
              Set As TOBERETURNED
            </b-button>
            <b-button block size="sm" v-if="incidenceReasons.find(x => x.id === typeSelected).name === 'unavailable_product' ||
              incidenceReasons.find(x => x.id === typeSelected).name === 'wrong_size' ||
              (typeSelected < 8 && incidenceReasons.find(x => x.id === typeSelected).name === 'absent_client') ||
              (typeSelected < 8 && incidenceReasons.find(x => x.id === typeSelected).name === 'unrecognized') ||
              (typeSelected < 8 && incidenceReasons.find(x => x.id === typeSelected).name === 'incorrect_address')"
              variant="danger" @click.prevent="editingShipping = row.item.id" style="padding: .05rem .65rem"
              v-b-modal.modalCanceledReason v-translate>
              Set As CANCELED
            </b-button>
            <b-button block size="sm" style="padding: .05rem .25rem" variant="warning"
              :href="transactionsLink(row.item.id)" target="_blank"
              v-if="(isSuperAdmin || isAccountant || isOperatorSupervisor)" v-translate>
              View Transactions
            </b-button>
          </div>
        </template>

        <template v-slot:row-details="row">
          <b-card>
            <ul>
              <li v-for="(value, key) in row.item" :key="key"
                v-if="value && value.length !== 0 && value !== 'undefined' && value !== null">{{ key }}: <span
                  v-html="key.indexOf('phone') === -1 ? isJson(value) : value.toString()"></span></li>
            </ul>
          </b-card>
        </template>

      </b-table>
    </div>

    <b-modal id="modalShowPicture" ref="modalShowPicture" size="lg" :hide-footer="true" @hidden="currentPicture = ''">
      <div slot="modal-title" v-translate>View picture</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <div class="w-100">
        <img :src="currentPicture" alt="" class="w-100">
      </div>
    </b-modal>

    <b-modal id="modalTobereturnedReason" ref="modalTobereturnedReason" :hide-footer="true">
      <div slot="modal-title" v-translate>TOBERETURNED Reason</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <b-form @submit.prevent="setAsTobereturned()">
        <b-form-group>
          <label for="incidence-desc" v-translate>To Be Returned reason</label>
          <b-form-radio-group v-model="tobereturnedDetails" name="tobereturnedDetails" required>
            <b-form-radio :value="{ reason: 'max_retries_reached' }" class="w-100">
              <translate>Maximum retries reached</translate>
            </b-form-radio>
            <b-form-radio v-for="(item, index) in tobereturnedStatusReasons"
              :value="{ reason: item.name, reason_id: item.reason_id }" class="w-100" :key="index">
              {{ item.description }}
            </b-form-radio>
            <b-form-radio :value="{ reason: 'other' }" class="w-100">
              <translate>Other</translate>
            </b-form-radio>
          </b-form-radio-group>
        </b-form-group>
        <b-form-group v-if="tobereturnedDetails.reason === 'other'">
          <label for="incidence-desc" v-translate>To Be Returned Description</label>
          <div class="input-group">
            <b-form-textarea id="incidence-desc" v-model="newShippingStatusMeta" rows="3" max-rows="6"
              :state="validateIncidenceDesc" required />
            <b-form-invalid-feedback :state="validateIncidenceDesc" v-translate>
              "Other" TOBERETURNED status requires a description for the client. Please be brief but descriptive.
            </b-form-invalid-feedback>
            <b-form-valid-feedback :state="validateIncidenceDesc" v-translate>
              Alright.
            </b-form-valid-feedback>
          </div>
        </b-form-group>
        <div class="text-right form-group col-12 form-actions">
          <b-button type="submit" variant="primary" size="lg" v-translate>Confirm TOBERETURNED</b-button>
          <b-button variant="outline-primary" size="lg"
            @click.prevent="editingShipping = null; $refs.modalTobereturnedReason.hide()" v-translate>Cancel</b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modalCanceledReason" ref="modalCanceledReason" :hide-footer="true">
      <div slot="modal-title" v-translate>CANCELED Reason</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <b-form @submit.prevent="setAsCanceled()">
        <div class="mb-3">
          <div class="invalid-feedback d-block" v-translate>
            CANCELED status requires to select/write a reason below before submit the new status.
          </div>
          <b-form-group>
            <label for="incidence-desc" v-translate>Cancel reason</label>
            <b-form-radio-group v-model="cancelDetails" name="cancelDetails" required>
              <b-form-radio :value="{ reason: 'canceled_by_client' }" class="w-100">
                <translate>Canceled by client</translate>
              </b-form-radio>
              <b-form-radio :value="{ reason: 'created_by_mistake' }" class="w-100">
                <translate>Created by mistake</translate>
              </b-form-radio>
              <b-form-radio :value="{ reason: 'other' }" class="w-100">
                <translate>Other</translate>
              </b-form-radio>
            </b-form-radio-group>
          </b-form-group>
          <b-form-group v-if="cancelDetails.reason === 'other'">
            <label for="incidence-desc" v-translate>Incidence Description</label>
            <div class="input-group">
              <b-form-textarea id="incidence-desc" v-model="newShippingStatusMeta" rows="3" max-rows="6"
                :state="validateIncidenceDesc" required />
              <b-form-invalid-feedback :state="validateIncidenceDesc" v-translate>
                "Other" CANCEL status requires a description. Please be brief but descriptive.
              </b-form-invalid-feedback>
              <b-form-valid-feedback :state="validateIncidenceDesc" v-translate>
                Alright.
              </b-form-valid-feedback>
            </div>
          </b-form-group>
        </div>
        <div class="text-right form-group col-12 form-actions">
          <b-button type="submit" variant="primary" size="lg" v-translate>Confirm CANCELED</b-button>
          <b-button variant="outline-primary" size="lg"
            @click.prevent="editingShipping = null; $refs.modalCanceledReason.hide()" v-translate>Cancel</b-button>
        </div>
      </b-form>
    </b-modal>
  </b-container>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import UserCard from '@/components/UserCard'

export default {
  name: 'IncidenceList',
  components: {
    DateRangePicker,
    UserCard
  },
  props: {
    title: {
      type: [String, Boolean],
      default: null
    },
    preFilters: {
      type: Array,
      default: () => {
        return []
      }
    },
    prePerPage: {
      type: Number,
      default: 500
    }
  },
  data() {
    return {
      type: 'shippings',
      shippingStatusReasons: {},
      tobereturnedStatusReasons: [],
      incidenceReasons: [],
      incidencesCount: [],
      incidences: [],
      typeSelected: null,
      fields: [],
      filterFields: this.$appConfig.models['shippings'].filters,
      exclude: this.$appConfig.models['shippings'].exclude,
      includes: this.$appConfig.models['shippings'].includes || [],
      allowDelete: this.$appConfig.models['shippings'].allowDelete,
      isBusy: false,
      currentPage: 1,
      perPage: this.prePerPage,
      totalRows: null,
      pageOptions: [10, 25, 50, 100, 500],
      sortBy: 'incidence_count',
      sortDesc: true,
      sortDirection: 'desc',
      filters: this.preFilters,
      dismissSecs: 5,
      dismissCountDown: 0,
      deleted: false,
      interval: 60000,
      intervalData: null,
      editingShipping: null,
      newShippingStatusMeta: '',
      tobereturnedDetails: {},
      cancelDetails: {},
      intervalCountdown: null,
      countdown: null,
      date_from: this.moment().endOf('day'),
      date_to: this.moment().subtract(6, 'days').startOf('day'),
      updatedDateRange: { // used for v-model prop
        startDate: this.moment().subtract(6, 'days').toDate(),
        endDate: this.moment().toDate()
      },
      opens: 'right', //  which way the picker opens, default "center", can be "left"/"right"
      locale: {},
      ranges: {},
      updatedDateRangeActive: 0,
      datepickerLocalized: false,
      backofficePreferences: {},
      backofficePreferencesActive: true,
      currentPicture: null,
      statuses: 'incidences',
      filterWarehouse: null,
      validPercentage: null
    }
  },
  computed: {
    validateIncidenceDesc() {
      return this.newShippingStatusMeta !== null && this.newShippingStatusMeta.length > 10
    },
    applyFilter() {
      return this.filter
    }
  },
  watch: {
    statuses: 'setInterval',
    updatedDateRangeActive: 'setInterval',
    filterWarehouse(val) {
      if (val) {
        this.$cookies.set('warehouse', val)
      } else {
        this.$cookies.remove('warehouse')
      }
      this.setInterval()
    },
    validPercentage(val) {
      if (val > 100) {
        this.validPercentage = 100
      } else if (val < 0) {
        this.validPercentage = 0
      }
    }
  },
  created() {
    this.fetchWarehouses()
    this.fetchVehicleTypes()
    // this.fetchIncidenceReasons()
  },
  mounted() {
    this.fields = [
      {
        key: 'id',
        sortable: true
      },
      {
        key: 'company_id',
        sortable: false,
        label: this.$gettext('Posted by')
      },
      {
        key: 'from_contact',
        sortable: true,
        label: this.$gettext('Origin')
      },
      {
        key: 'to_contact',
        sortable: true,
        label: this.$gettext('Destination')
      },
      {
        key: 'courier',
        sortable: false,
        label: this.$gettext('Courier')
      },
      {
        key: 'incidence_count',
        sortable: true,
        label: this.$gettext('Incidences Count')
      },
      {
        key: 'photos',
        label: this.$gettext('Photos')
      },
      {
        key: 'updated_at',
        sortable: true,
        label: this.$gettext('Updated At')
      }
    ]
    this.fields.push({ key: 'actions', label: this.$gettext('Actions') })
    this.filterWarehouse = this.$cookies.get('warehouse') || null
    this.initDatePicker()
    this.setInterval()
  },
  beforeDestroy() {
    clearInterval(this.intervalData)
    clearInterval(this.intervalCountdown)
  },
  methods: {
    filterIncidenceTypes(incidences) {
      return [...new Set(incidences.filter(x => x.status === 'INCIDENCE').map(x => { return x.details.reason }))]
    },
    countIncidenceTypes(incidences, type) {
      return incidences.filter(x => x.status === 'INCIDENCE' && x.details.reason === type).length
    },
    setInterval() {
      clearInterval(this.intervalData)
      this.fetchIncidenceReasons()
      this.intervalData = setInterval(function () {
        this.fetchIncidenceReasons()
      }.bind(this), this.interval)
    },
    setIntervalCountdown() {
      clearInterval(this.intervalCountdown)
      this.intervalCountdown = setInterval(function () {
        this.countdown = this.countdown === 0 ? 0 : this.countdown - 1
      }.bind(this), 1000)
    },
    initDatePicker() {
      this.locale = {
        direction: 'ltr', //  direction of text
        format: 'dd/mm/yyyy', //  fomart of the dates displayed
        separator: ' - ', //  separator between the two ranges
        applyLabel: this.$gettext('Apply'),
        cancelLabel: this.$gettext('Cancel'),
        weekLabel: 'W',
        customRangeLabel: this.$gettext('Custom Range'),
        daysOfWeek: this.moment.weekdaysMin(), // days, //  array of days - see moment documenations for details
        monthNames: this.moment.monthsShort(), //  array of month names - see moment documenations for details
        firstDay: 1,
        showWeekNumbers: false //  show week numbers on each row of the calendar
      }
      this.ranges = {
        [this.$gettext('Today')]: [this.moment().toDate(), this.moment().toDate()],
        [this.$gettext('Yesterday and Today')]: [this.moment().subtract(1, 'days').toDate(), this.moment().subtract(0, 'day').toDate()],
        [this.$gettext('Last 7 days')]: [this.moment().subtract(6, 'day').toDate(), this.moment().subtract(0, 'day').toDate()],
        [this.$gettext('Last 30 days')]: [this.moment().subtract(29, 'day').toDate(), this.moment().subtract(0, 'day').toDate()],
        [this.$gettext('Last 120 days')]: [this.moment().subtract(120, 'day').toDate(), this.moment().subtract(0, 'day').toDate()]
      }
      this.datepickerLocalized = true
    },
    resetupdatedDateRange() {
      this.updatedDateRange = {
        startDate: this.moment().toDate(),
        endDate: this.moment().toDate()
      }
      this.date_to = this.moment(this.updatedDateRange.startDate)
      this.date_from = this.moment(this.updatedDateRange.endDate)
      this.updatedDateRangeActive = 0
      this.fetchIncidenceReasons()
    },
    updateValues(obj) {
      this.date_to = this.moment(this.updatedDateRange.startDate).startOf('day')
      this.date_from = this.moment(this.updatedDateRange.endDate).endOf('day')
      this.updatedDateRangeActive++
      this.fetchIncidenceReasons()
    },
    markAsNew(item, type) {
      if (!item) {
        return
      }
      if (item.new === true) {
        return 'highlight'
      }
    },
    setAsWaiting(id) {
      this.$http.patch(this.$appConfig.api.baseUrl + 'shippings/' + id, { courier_id: null })
        .then(response => {
          let params = {
            shipping_id: id,
            user_id: this.$store.getters.profile.id,
            status: 'WAITING'
          }
          this.$http.post(this.$appConfig.api.baseUrl + 'status', params)
            .then(response => {
              this.fetchIncidenceReasons()
            })
        })
    },
    setAsReady(id) {
      this.$http.patch(this.$appConfig.api.baseUrl + 'shippings/' + id, { courier_id: null })
        .then(response => {
          let params = {
            shipping_id: id,
            user_id: this.$store.getters.profile.id,
            status: 'READY'
          }
          this.$http.post(this.$appConfig.api.baseUrl + 'status', params)
            .then(response => {
              this.fetchIncidenceReasons()
            })
        })
    },
    setAsTobereturned() {
      let id = this.editingShipping
      this.$http.patch(this.$appConfig.api.baseUrl + 'shippings/' + id, { courier_id: null })
        .then(response => {
          let params = {
            shipping_id: id,
            user_id: this.$store.getters.profile.id,
            status: 'TOBERETURNED',
            meta: this.newShippingStatusMeta || null,
            details: this.tobereturnedDetails
          }

          this.$http.post(this.$appConfig.api.baseUrl + 'status', params)
            .then(response => {
              this.editingShipping = null
              this.newShippingStatusMeta = ''
              this.tobereturnedDetails = {}
              this.fetchIncidenceReasons()
              this.$refs.modalTobereturnedReason.hide()
            })
        })
    },
    setAsCanceled() {
      let id = this.editingShipping
      let params = {
        shipping_id: id,
        user_id: this.$store.getters.profile.id,
        status: 'CANCELED',
        meta: this.newShippingStatusMeta || null,
        details: this.cancelDetails
      }
      this.$http.post(this.$appConfig.api.baseUrl + 'status', params)
        .then(response => {
          this.editingShipping = null
          this.newShippingStatusMeta = ''
          this.cancelDetails = {}
          this.fetchIncidenceReasons()
          this.$refs.modalCanceledReason.hide()
        })
    },
    fetchIncidenceReasons() {
      this.countdown = this.interval / 1000
      this.setIntervalCountdown()
      if (this.incidenceReasons.length === 0) {
        this.$http.get(this.$appConfig.api.baseUrl + 'shipping-status-reasons')
          .then(response => {
            this.shippingStatusReasons = {}
            for (let i = 0; i < response.body.data.length; i++) {
              if (response.body.data[i].event !== 'CANCELED') {
                if (!this.shippingStatusReasons[response.body.data[i].event]) {
                  this.shippingStatusReasons[response.body.data[i].event] = []
                }

                if (response.body.data[i].event === 'PICKEDUP') {
                  response.body.data[i].event = 'CONFIRMED'
                } else if (response.body.data[i].event === 'DELIVERED') {
                  this.tobereturnedStatusReasons.push({ name: response.body.data[i].name, description: response.body.data[i].description, reason_id: response.body.data[i].id })
                  response.body.data[i].event = 'INTRANSIT'
                }
                this.fectchIncidences(response.body.data[i].id)
                this.shippingStatusReasons[response.body.data[i].event].push({ name: response.body.data[i].name, description: response.body.data[i].description, reason_id: response.body.data[i].id })
              }
            }
            this.incidenceReasons = response.body.data
          })
      } else {
        for (const incidenceReason of this.incidenceReasons) {
          this.fectchIncidences(incidenceReason.id)
        }
      }
    },
    fectchIncidences(id) {
      let params = {
        incidence_type_id: id,
        includes: [
          'status_history',
          'user',
          'company'
        ],
        date_to: this.date_from.utc().format('YYYY-MM-DD'),
        time_to: this.date_from.utc().format('HH:mm:ss'),
        date_from: this.date_to.utc().format('YYYY-MM-DD'),
        time_from: this.date_to.utc().format('HH:mm:ss'),
        sort: [
          {
            key: 'incidence_count',
            direction: 'desc'
          },
          {
            key: 'updated_at',
            direction: 'asc'
          }
        ],
        filter_groups: []
      }

      // Backoffice Prefs?
      if (this.$store.getters.profile.meta) {
        let meta
        try {
          meta = JSON.parse(this.$store.getters.profile.meta)
        } catch (e) {
          meta = this.$store.getters.profile.meta
        }
        this.backofficePreferences = meta.backofficePreferences
        if (this.backofficePreferences && this.backofficePreferencesActive) {
          if (this.backofficePreferences.companies.include.ids.length === 0 && this.backofficePreferences.companies.exclude.ids.length > 0) {
            params.filter_groups[0] = {
              filters: [
                ['company_id', 'in', this.backofficePreferences.companies.exclude.ids, true]
              ]
            }
          } else if (this.backofficePreferences && this.backofficePreferences.companies.include.ids.length > 0) {
            params.filter_groups[0] = {
              filters: [
                ['company_id', 'in', this.backofficePreferences.companies.include.ids]
              ]
            }
          }
        }
      }

      if (this.statuses === 'incidences') {
        params.filter_groups.push({
          filters: [
            ['status', 'eq', 'INCIDENCE']
          ]
        })
      }

      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['from_country_iso_code', 'eq', window.country]
            ]
          }
        )
      }

      if (this.validPercentage) {
        params.photo_valid_from = 0
        params.photo_valid_to = this.validPercentage
      }

      if (this.filterWarehouse) {
        params.filter_groups.push(
          {
            filters: [
              ['last_known_place_id', 'eq', this.filterWarehouse]
            ]
          }
        )
      }

      this.$http.get(this.$appConfig.api.baseUrl + 'shippings/with-incidence', { params: params })
        .then(response => {
          if (typeof this.incidencesCount !== 'undefined' && typeof this.incidencesCount[id] !== 'undefined') {
            this.incidencesCount[id] = null
          }
          if (typeof this.incidences !== 'undefined' && typeof this.incidences[id] !== 'undefined') {
            let newIds = response.body.data.filter(({ id: id1 }) => !this.incidences[id].some(({ id: id2 }) => id2 === id1))
            for (const newId of newIds) {
              let idx = response.body.data.findIndex(x => x.id === newId.id)
              response.body.data[idx]['new'] = true
            }
            this.incidences[id] = []
          }

          this.$set(this.incidencesCount, id, response.body.pagination.total)
          this.$set(this.incidences, id, response.body.data)
        })
    },
    transactionsLink(id) {
      return '/transactions?qs=' + JSON.stringify({
        type: [],
        relationship: [],
        shippingId: ['shipping_id', 'in', [id]],
        company: [],
        user: [],
        country: [],
        createdAtFrom: [],
        createdAtTo: [],
        imputationDateFrom: []
      })
    },
    refreshTable(filters) {
      console.log(filters)
      this.filters = filters
      setTimeout(() => {
        this.$root.$emit('bv::refresh::table', this.type)
      }, 100)
    },
    resetData: function () {
      Object.assign(this.$data, this.$options.data.call(this))
    }
  }
}
</script>

<style lang="scss">
.highlight {
  border-radius: 3px;
  animation: highlight 3000ms ease;
}

@keyframes highlight {
  0% {
    background-color: #ffff66;
  }

  100% {
    background-color: #ffffff;
  }
}
</style>
